import {
  Colors,
  IcMediaLibrary,
  IcPlaylist,
  IcScreen,
  Tabs,
  Text,
} from 'basic-ui-lib';
import React, { useState } from 'react';
import styled from 'styled-components';
import Header from './components/Header';
import StoreStatis from './components/StoreStatis';
import { TabsProps } from 'antd';
import MediaTabs from './components/MediaTabs';
import ScreenTabs from './components/ScreenTabs';
import PlaylistTabs from './components/PlaylistTabs';
import { useParams } from 'react-router-dom';
import useGetSummaryStore from 'modules/store/services/hooks/useGetSummaryStore';
import useGetDetailStore from 'modules/store/services/hooks/useGetDetailStore';

const StoreOverview = () => {
  const [activeTab, setActiveTab] = useState('screens');
  const { id } = useParams<{ id: string }>();
  const { summaryStore } = useGetSummaryStore(id || '');
  const { detailStore } = useGetDetailStore(id || '');

  const items: TabsProps['items'] = [
    {
      key: 'screens',
      label: (
        <StyledLabelTab>
          <IcScreen
            fill={
              activeTab === 'screens'
                ? Colors.primary[6]
                : Colors.neutral.text[3]
            }
            width={20}
            height={20}
          />
          <Text
            title_h8
            medium
            color={activeTab === 'screens' ? 'primary.6' : 'neutral.text.3'}
          >
            Screens
          </Text>
          <CountBox className={activeTab === 'screens' ? 'active' : ''}>
            {summaryStore?.totalOnline + summaryStore?.totalOffline}
          </CountBox>
        </StyledLabelTab>
      ),
    },
    {
      key: 'playlist',
      label: (
        <StyledLabelTab>
          <IcPlaylist
            fill={
              activeTab === 'playlist'
                ? Colors.primary[6]
                : Colors.neutral.text[3]
            }
            width={20}
            height={20}
          />
          <Text
            title_h8
            medium
            color={activeTab === 'playlist' ? 'primary.6' : 'neutral.text.3'}
          >
            Playlist
          </Text>
          <CountBox className={activeTab === 'playlist' ? 'active' : ''}>
            {summaryStore?.playlistActive}
          </CountBox>
        </StyledLabelTab>
      ),
    },
    {
      key: 'media',
      label: (
        <StyledLabelTab>
          <IcMediaLibrary
            fill={
              activeTab === 'media' ? Colors.primary[6] : Colors.neutral.text[3]
            }
            width={20}
            height={20}
          />
          <Text
            title_h8
            medium
            color={activeTab === 'media' ? 'primary.6' : 'neutral.text.3'}
          >
            Media
          </Text>
          <CountBox className={activeTab === 'media' ? 'active' : ''}>
            {summaryStore?.totalImages + summaryStore?.totalVideos}
          </CountBox>
        </StyledLabelTab>
      ),
    },
  ];

  return (
    <Wrapper>
      {/* ================= STORE HEADER ================= */}
      <Header data={detailStore} />

      {/* ================= STATISTICS ================= */}
      <StoreStatis data={summaryStore} />

      {/* ================= TABS ================= */}
      <Tabs items={items} activeKey={activeTab} onChange={setActiveTab} className='styled-tabs'/>
      {activeTab === 'screens' && <ScreenTabs />}

      {activeTab === 'playlist' && <PlaylistTabs />}

      {activeTab === 'media' && <MediaTabs />}
    </Wrapper>
  );
};

export default StoreOverview;

const Wrapper = styled.div`
  width: 100%;

  .styled-tabs {
    .ant-tabs-ink-bar {
      background: ${Colors.primary[6]};
    }
  }
`;

const StyledLabelTab = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CountBox = styled.div`
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${Colors.neutral.bg[4]};
  border-radius: 50%;
  font-size: 14px;
  font-weight: 500;
  color: ${Colors.neutral.text[3]};
  font-family: 'Poppins';

  &.active {
    background: ${Colors.primary[6]};
    color: ${Colors.neutral.text[1]};
  }
`;
